import api from "@/router/api";

let cacheUnidadesTodas = null;

export default {
  async getAllUnidades(page, size) {
    if (size >= 1000 && cacheUnidadesTodas) {
      return cacheUnidadesTodas;
    }

    const response = await api.get("/unidades", {
      params: { page, size },
      public: true,
    });

    if (size >= 1000) {
      cacheUnidadesTodas = response.data?.content || response.data;
    }
    return response.data?.content || response.data;
  },

  async postUnidades(name) {
    const response = await api.post("/unidades", { nome: name });
    return response.data;
  },

  async getUnidadesById(unidadeId) {
    const response = await api.get(`/unidades/${unidadeId}`);
    return response.data;
  },

  // Busca parcial (contém, sem acento/caixa); devolve Page<{id, nome}>
  async getUnidadesByNome(nome, page = 0, size = 10) {
    const response = await api.get("/unidades/busca", {
      params: { nome, page, size },
    });
    return response.data;
  },
};
